export const ADMIN_ROLES = ["admin", "ops_admin", "dev_admin"];
export const DEV_ADMIN_ROLES = ["admin", "dev_admin"];

export const ROLE_LABELS = {
  user: "일반",
  ops_admin: "운영관리자",
  dev_admin: "개발관리자",
  admin: "최고관리자",
};

export function isAdminRole(role) {
  return ADMIN_ROLES.includes(role);
}

export function isDevAdminRole(role) {
  return DEV_ADMIN_ROLES.includes(role);
}

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || "-";
}
